export default __webpack_public_path__ + "zap-imoveis-ok.png?df01e274ee330f621fff10fdce2b1854";